import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopDettagliantiFormService } from './scheda-coop-dettaglianti-form.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  providers: [
    SchedaCoopDettagliantiFormService
  ]
})
export class SchedaCoopDettagliantiFormModule { }
